import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Aka } from '../../../models/aka';

import { AkaService } from '../../../services/contacts/aka.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-aka-form',
  templateUrl: './aka-form.component.html',
  styleUrls: ['./aka-form.component.scss'],
})
export class AkaFormComponent implements OnInit, OnChanges {
  /**
   * Contact id for aka
   */
  @Input() contactId: number;

  /**
   * Aka being created/edited
   */
  @Input() aka: Aka = new Aka();

  /**
   * Emit saved event to parent component
   * @param {EventEmitter<boolean> = new EventEmitter(} ) saved Event emitter to emit saved event to parent component
   */
  @Output() saved: EventEmitter<boolean> = new EventEmitter();

  /**
   * Default form options
   * @type {any}
   */
  formOptions: any = {
    aka_types: [],
  };

  /**
   * Indicates if form has been submitted atleast once
   * @type {boolean}
   */
  formSubmitted: boolean = false;

  /**
   * Indicates if form is processing
   * @type {boolean}
   */
  formSubmitting: boolean = false;

  constructor(private akaService: AkaService, private notyService: NotyService) {
    this.akaService.formOptions().then((response_json) => (this.formOptions = response_json));
  }

  // Component lifecycle methods
  ngOnInit() {
    if (this.contactId) this.aka.contact_id = this.contactId;
    if (!this.aka.id)
      this.akaService.formOptions().then((response_json) => {
        this.formOptions = response_json;
        if (this.formOptions.aka_types && this.formOptions.aka_types[0]) this.aka.aka_type_id = this.formOptions.aka_types[0].value;
      });
  }

  /**
   * Called when component variable changes
   * @param {SimpleChanges} changes Object with variables changed in component
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.contactId && changes.contactId.currentValue) this.aka.contact_id = this.contactId;
  }

  /**
   * Save AKA
   * @param {NgForm} currentForm Angular form
   */
  save(currentForm: NgForm) {
    this.formSubmitted = true;
    if (!currentForm.form.valid) {
      this.notyService.notify('Please check the form again', 'error', 5000, 'topRight');
      return;
    }
    this.formSubmitting = true;
    this.akaService
      .save(this.aka)
      .then((response_json) => {
        this.formSubmitting = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'AKA saved', 'success', 5000, 'topRight');
          this.saved.emit(true);
          if (!this.aka.id) {
            this.aka = new Aka();
            this.aka.contact_id = this.contactId;
            if (this.formOptions.aka_types && this.formOptions.aka_types[0]) this.aka.aka_type_id = this.formOptions.aka_types[0].value;
          }
        } else this.notyService.notify(response_json.text || 'Error saving AKA', 'error', 5000, 'topRight');
      })
      .catch(() => {
        this.formSubmitting = false;
        this.notyService.notify('Error saving AKA', 'error', 5000, 'topRight');
      });
  }
}
